import styled from 'styled-components';
import { fontFamily, fontSize } from '../../constants';

export const HeadingText = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* gap: 1rem; */
  padding: 2rem;
  padding-bottom: 1rem;
  border-bottom: ${({ theme }) => `1px solid ${theme.text.gray}`};
`;

export const FilterText = styled.span`
  font-size: ${fontSize.text};
  font-family: ${fontFamily.circularMedium};
  color: ${({ theme }) => theme.text.gray};
`;

export const FilterLeftContainer = styled.div`
  background: ${({ theme }) => theme.body};
  height: 100%;
  flex: 0 1 40%;
`;

export const FilterRightContainer = styled.div`
  height: 100%;
  flex: 0 1 60%;
  margin: 2rem;
`;

export const FilterBody = styled.div`
  display: flex;
  height: calc(100% - 10rem);
`;

export const FilterIndividualText = styled.div`
  padding: 2rem 1rem;
  font-size: ${fontSize.medium};
  font-family: ${fontFamily.circularBold};
  color: ${({ theme }) => theme.text.gray};
  &.highLighted {
    background-color: #d1d1d1;
  }
`;

export const SubOptionText = styled.div`
  margin-left: 1rem;
  font-size: ${fontSize.medium};
  font-family: ${fontFamily.circularBold};
  color: ${({ theme }) => theme.text.gray};
`;

export const FooterContainer = styled.div`
  background-color: ${({ theme }) => theme.core.secondary};
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px -3px 6px #0000001a;
  padding: 2rem 0;
`;
